const compassEN = {
  compass_nav_home: 'Home',
  compass_nav_about: 'About',
  compass_nav_licenses: 'Mining Licenses',
  compass_nav_investment: 'Investment',
  compass_nav_contact: 'Contact',
  compass_nav_cta: 'Partner With Us',

  compass_hero_title: "Unlocking Mauritania's\nMineral Wealth",
  compass_hero_subtitle: 'Forward-thinking exploration • Sustainable exploitation • Community development',
  compass_hero_cta1: 'Explore Our Licenses',
  compass_hero_cta2: 'Investment Opportunities',
  compass_hero_stat1_label: 'Total License Area',
  compass_hero_stat2_label: 'Mineral Resources',
  compass_hero_stat3: '100%',
  compass_hero_stat3_label: 'GDSATLAS Owned',
  compass_hero_stat4: 'Global',
  compass_hero_stat4_label: 'Standards',

  compass_about_tag: 'Who We Are',
  compass_about_title: 'Forward-Thinking Mining\nExcellence in Mauritania',
  compass_about_p1: 'Compass Resources Mauritania is a forward-thinking company dedicated to the exploration and sustainable exploitation of natural resources in Mauritania. Founded by a team of seasoned experts, we aim to harness the country\'s rich mineral potential while prioritizing sustainability, innovation, and community development.',
  compass_about_p2: 'Our team is actively engaged in fieldwork, conducting detailed geological studies to transform these opportunities into viable, sustainable projects that meet global standards.',
  compass_about_quote: 'We hold multiple licenses covering some of the most sought-after resources, including Gold, Uranium, Iron ore, Copper, Black sand, and Quartz.',

  compass_licenses_tag: 'Our Assets',
  compass_licenses_title: 'Strategic Mining Licenses',
  compass_licenses_subtitle: 'Compass Resources holds multiple licenses across 1,352 km² of highly prospective terrain',

  compass_gold_title: 'Gold License',
  compass_gold_badge: '204 km²',
  compass_gold_desc: "Compass Resources' gold license encompasses 204 km² of highly prospective terrain. With increasing global demand for gold as both a financial asset and a raw material for various industries, this license holds enormous potential. Our exploration efforts aim to discover and develop significant gold reserves, contributing to both economic growth and investor returns.",
  compass_gold_cta: 'High-Potential Gold Reserves',

  compass_uranium_title: 'Uranium License',
  compass_uranium_badge: '486 km²',
  compass_uranium_desc: 'Compass Resources holds a strategic uranium exploration license covering an extensive surface area of 486 km². This region is rich in uranium deposits, with significant potential to contribute to the global demand for clean energy. Our focus on uranium aligns with the growing transition to sustainable energy solutions worldwide, positioning Compass Resources as a key player in the nuclear energy value chain.',
  compass_uranium_cta: 'Clean Energy Future',

  compass_quartz_title: 'Quartz License',
  compass_quartz_badge: '150 km²',
  compass_quartz_desc: 'Our quartz license spans an area of 150 km², offering immense potential for industrial and technological applications. Quartz is a critical mineral used in electronics, glass manufacturing, and solar panels. Compass Resources is committed to unlocking the value of this resource, ensuring high-quality quartz supply to meet the increasing global demand.',
  compass_quartz_cta: 'Technology & Electronics',

  compass_copper_title: 'Copper License',
  compass_copper_badge: '471 km²',
  compass_copper_desc: 'Our copper license extends over an impressive surface area of 471 km², a region known for its high-grade copper deposits. Copper is indispensable for modern infrastructure, renewable energy systems, and electronics. This license reinforces Compass Resources\' commitment to supporting global industrial growth and the green energy transition.',
  compass_copper_cta: 'Green Energy Transition',

  compass_blacksand_title: 'Black Sand License',
  compass_blacksand_badge: '41 km²',
  compass_blacksand_desc: 'The black sand license covers a targeted area of 41 km², renowned for its high mineral content, including rare earth elements and heavy metals. These resources are vital for the production of advanced materials in aerospace, electronics, and renewable energy sectors. Compass Resources aims to develop sustainable extraction techniques to maximize the potential of this unique resource.',
  compass_blacksand_cta: 'Rare Earth Elements',

  compass_iron_title: 'Iron Ore License',
  compass_iron_badge: 'Strategic Asset',
  compass_iron_desc: "Our iron ore license represents a strategic asset in Mauritania's mining landscape. Iron ore is fundamental to global infrastructure development and steel production. With Mauritania's established reputation as a major iron ore producer, this license positions Compass Resources to contribute to the global supply chain while supporting local economic development.",
  compass_iron_cta: 'Infrastructure Development',

  compass_inv_title: "Your Greatest Partner\nin Mauritania's Mining Sector",
  compass_inv_subtitle: "Take advantage of investing in Mauritania's mining sector which offers exciting investment opportunities, with abundant resources like iron ore, gold, copper, uranium, and more.",
  compass_inv_card1_title: 'Government Support',
  compass_inv_card1_desc: 'Tax incentives and streamlined regulations supporting foreign investment in the mining sector',
  compass_inv_card2_title: 'Improved Infrastructure',
  compass_inv_card2_desc: 'Enhanced transportation networks and port facilities boosting operational efficiency',
  compass_inv_card3_title: 'Strategic Access',
  compass_inv_card3_desc: 'Direct access to international markets with rising global demand for critical minerals',
  compass_inv_cta_title: 'Seeking International Partners',
  compass_inv_cta_desc: 'We are seeking international partners with the expertise and resources to transform our exploration sites into world-class mining operations.',
  compass_inv_cta1: 'Partner With Us',
  compass_inv_cta2: 'Request Information',

  compass_contact_tag: 'Get In Touch',
  compass_contact_title: 'Let\'s Discuss Your Investment',
  compass_contact_subtitle: "Contact Compass Resources to explore partnership opportunities in Mauritania's mining sector",
  compass_contact_addr_label: 'Address',
  compass_contact_phone_label: 'Phone',
  compass_contact_email_label: 'Email',
  compass_contact_parent_label: 'Parent Company',
  compass_contact_note: 'Compass Resources is a wholly-owned subsidiary of GDSATLAS, specializing in sustainable mining and mineral exploration in Mauritania.',
  compass_form_title: 'Send us a message',
  compass_form_name: 'Name',
  compass_form_name_ph: 'Your name',
  compass_form_email: 'Email',
  compass_form_email_ph: 'your@email.com',
  compass_form_message: 'Message',
  compass_form_message_ph: 'Tell us about your investment interest',
  compass_form_submit: 'Send Message',

  compass_footer_tagline: "Unlocking Mauritania's mineral wealth through sustainable exploration and responsible mining practices.",
  compass_footer_subsidiary: 'A wholly-owned subsidiary of GDSATLAS Holding',
  compass_footer_back: 'Back to GDSATLAS Holding',
  compass_footer_links: 'Quick Links',
  compass_footer_about: 'About Us',
  compass_footer_licenses: 'Mining Licenses',
  compass_footer_investment: 'Investment',
  compass_footer_contact: 'Contact',
  compass_footer_copyright: '© 2025 Compass Resources Mauritania. A GDSATLAS Company. All rights reserved.',
};

export default compassEN;
